export default "__VITE_ASSET__CZneoY4H__"